// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"672":"c60a36d1","684":"dcea10c9","774":"2fe5b767"}[chunkId] + ".css";
};